module.exports = __webpack_public_path__ + "src/assets/images/word_icon.2bb96600e3d0659bde8bd419440ec33d.png";